export default "__VITE_ASSET__Djov$c_w__"